import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import './toolbar.css';
import {
  setActiveTool, setActiveShape,
  setFillColor, setStrokeColor, setStrokeWidth,
  setFontFamily, setFontSize, setBold, setTextAlign,
} from '../../../../../store/slices/drawingToolbarSlice';
import { removeShapes } from '../../../../../store/slices/drawingSlice';
import { removeItem, updateItem }   from '../../../../../store/slices/imageOverlaySlice';
import useImageImport from "../../../../../components/map/components/Map/Image/Useimageimport";
import { CircleSvg, EraseSvg, FillSvg, ImportSvg, PolygonSvg, RectangleSvg } from "../../../../../components/common/svgIcons"; 
 
const PenIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>
  </svg>
);
const HighlighterIcon = () => ( 
  <FillSvg fill="#A8ABAF"/>
);
const TextIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/>
  </svg>
);
const EraserIcon = () => ( 
  <EraseSvg fill="#A8ABAF"/>
);
const SelectIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 3l14 9-7 1-4 7z"/>
  </svg>
);
const ImportSVGIcon = () => ( 
  <ImportSvg fill={"#6a6d73"}/>
);
const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);
const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
    <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
  </svg>
);
const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);
const ReplaceIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 4v6h6"/><path d="M23 20v-6h-6"/>
    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
  </svg>
);
const ChevronDown = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);
const FreehandIcon = () => ( 
  <PolygonSvg fill={'#A8ABAF'} />
);
const RectIcon = () => ( 
  <RectangleSvg fill={'#A8ABAF'}/>
);
const CircleIcon = () => ( 
  <CircleSvg fill={'#A8ABAF'}/>
);
const AlignLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="18" y2="18"/>
  </svg>
);
const AlignCenterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/>
  </svg>
);
const AlignRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6"/><line x1="9" y1="12" x2="21" y2="12"/><line x1="6" y1="18" x2="21" y2="18"/>
  </svg>
);
 
const ColorSwatch = ({ color, label, onChange }) => {
  const inputRef = useRef(null);
  return (
    <button className="color-swatch" onClick={() => inputRef.current?.click()} title={`Change ${label}`} style={{ "--swatch": color }}>
      <span className="swatch-box" />
      <span className="swatch-hex">{color.toUpperCase()}</span>
      <input ref={inputRef} type="color" value={color} onChange={(e) => onChange(e.target.value)}
        style={{ position: "absolute", opacity: 0, width: 0, height: 0 }} />
    </button>
  );
};

const StrokeControl = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <div ref={containerRef} style={{ position: "relative" }}>
      <button className="stroke-btn" onClick={() => setOpen(v => !v)}>
        <span className="stroke-lines-icon">
          {[2, 3, 4].map((w, i) => <span key={i} style={{ height: w, opacity: i === 1 ? 1 : 0.45 }} />)}
        </span>
        <span className="swatch-hex">{value}</span>
      </button>
      {open && (
        <div className="dropdown-panel" style={{ minWidth: 64 }}>
          {[1, 2, 3, 4, 6].map(n => (
            <button key={n} className={`dropdown-item stroke-option ${n === value ? "active" : ""}`}
              onClick={() => { onChange(n); setOpen(false); }}>
              <span style={{ display: "block", height: n, background: "currentColor", borderRadius: 2, width: "100%" }} />
              <span style={{ fontSize: 11, marginTop: 2 }}>{n}px</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const FONTS = [
  'Arial', 'Roboto', 'Impact', 'Times New Roman', 'Courier New',
  'Verdana', 'Georgia', 'Garamond', 'monospace',
];
const SIZES = [ 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72,];

const FontFamilyPicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} style={{ position: "relative" }} onMouseDown={e => e.stopPropagation()}>
      <button type="button" className="text-select" onClick={() => setOpen(v => !v)} style={{ minWidth: 136 }}>
        <span style={{ fontFamily: value }}>{value}</span>
        <ChevronDown />
      </button>
      {open && (
        <div className="dropdown-panel" style={{ minWidth: 170 }}>
          {FONTS.map(f => (
            <button type="button" key={f} className={`dropdown-item ${f === value ? "active" : ""}`}
              style={{ fontFamily: f }} onClick={() => { onChange(f); setOpen(false); }}>{f}</button>
          ))}
        </div>
      )}
    </div>
  );
};

const FontSizePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} style={{ position: "relative" }} onMouseDown={e => e.stopPropagation()}>
      <button type="button" className="text-select" onClick={() => setOpen(v => !v)} style={{ minWidth: 60 }}>
        <span>{value}</span>
        <ChevronDown />
      </button>
      {open && (
        <div className="dropdown-panel" style={{ minWidth: 70 }}>
          {SIZES.map(s => (
            <button type="button" key={s} className={`dropdown-item ${s === value ? "active" : ""}`}
              onClick={() => { onChange(s); setOpen(false); }}>{s}</button>
          ))}
        </div>
      )}
    </div>
  );
};
 
export default function DrawingToolbar() {
  const dispatch = useDispatch();
  const { openImagePicker, openReplaceImagePicker } = useImageImport();
 
  useEffect(() => {
    dispatch(setActiveTool('select'));
    return () => {
      dispatch(setActiveTool(null));
    };
  }, [dispatch]);
 
  const selectedIds      = useSelector((s) => s.drawing.selectedIds);
  const shapes           = useSelector((s) => s.drawing.shapes);
  const selectedImageId  = useSelector((s) => s.imageOverlay.selectedId);
  const imageItems       = useSelector((s) => s.imageOverlay.items);
  const hasSelection     = selectedIds.length > 0 || selectedImageId !== null;
 
  const selectedIsText =
    selectedIds.length > 0 &&
    shapes.find((s) => s.id === selectedIds[0])?.properties?.shapeType === 'text';

  const handleDelete = () => {
    if (selectedIds.length > 0)   dispatch(removeShapes(selectedIds));
    if (selectedImageId !== null) dispatch(removeItem(selectedImageId));
  };

  const handleDownloadImage = () => {
    const item = imageItems.find((i) => i.id === selectedImageId);
    if (!item) return;
    const a = document.createElement('a');
    a.href = item.src;
    a.download = 'reference-image.png';
    a.click();
  };

  const handleReplaceImage = () => {
    const item = imageItems.find((i) => i.id === selectedImageId);
    if (!item) return;
    openReplaceImagePicker(item);
  };
 
  const activeTool  = useSelector((s) => s.drawingToolbar.activeTool);
  const activeShape = useSelector((s) => s.drawingToolbar.activeShape);
  const fillColor   = useSelector((s) => s.drawingToolbar.fillColor);
  const strokeColor = useSelector((s) => s.drawingToolbar.strokeColor);
  const strokeWidth = useSelector((s) => s.drawingToolbar.strokeWidth);
  const fontFamily  = useSelector((s) => s.drawingToolbar.fontFamily);
  const fontSize    = useSelector((s) => s.drawingToolbar.fontSize);
  const bold        = useSelector((s) => s.drawingToolbar.bold);
  const textAlign   = useSelector((s) => s.drawingToolbar.textAlign);

  const tools = [
    { id: "pen",         icon: <PenIcon />,        label: "Pen"         },
    { id: "highlighter", icon: <HighlighterIcon />, label: "Highlighter" },
    { id: "text",        icon: <TextIcon />,        label: "Text"        },
    { id: "eraser",      icon: <EraserIcon />,      label: "Eraser"      },
    { id: "select",      icon: <SelectIcon />,      label: "Select"      },
  ];

  const showShapeBar     = activeTool === "pen";
  const showTextBar      = activeTool === "text" || (activeTool === "select" && selectedIsText);
  const showDownloadImage = activeTool === "select" && selectedImageId !== null;

  return (
    <div className="scene mt-2">
      <div className="toolbar">
        <div className="tools-section">
          <div className="tools-row">
            {tools.map((t) => (
              <button key={t.id} className={`tool-btn ${activeTool === t.id ? "active" : ""}`}
                onClick={() => dispatch(setActiveTool(t.id))} title={t.label}>
                {t.icon}
              </button>
            ))}
          </div>
          <span className="section-label">Tools</span>
        </div>

        <div className="divider" />

        <div className="section">
          <div className="section-inner">
            <ColorSwatch color={fillColor} label="fill" onChange={(c) => dispatch(setFillColor(c))} />
          </div>
          <span className="section-label">Fill</span>
        </div>

        <div className="divider" />

        <div className="section">
          <div className="section-inner">
            <ColorSwatch color={strokeColor} label="stroke" onChange={(c) => dispatch(setStrokeColor(c))} />
            <StrokeControl value={strokeWidth} onChange={(w) => dispatch(setStrokeWidth(w))} />
          </div>
          <span className="section-label">Stroke</span>
        </div>

        <div className="divider" /> 

        <button className="ref-btn" title="Add Reference Image" onClick={(e)=>{
          dispatch(setActiveTool(null))
          openImagePicker(e)
        }}>
          <PlusIcon />
          <span>Upload Image</span>
        </button>

        {hasSelection && (
          <>
            <div className="divider" />
            <button
              className="ref-btn"
              title="Delete selected"
              onClick={handleDelete}
              style={{ color: '#e03131',border:"none" }}
            >
              <TrashIcon />
              <span>Delete</span>
            </button>
          </>
        )}
      </div>

      {showDownloadImage && (
        <div className="sub-toolbar">
          <button className="shape-btn" style={{ gap: 6, padding: '0px 15px', width: 'auto' }} title="Download selected image" onClick={handleDownloadImage}>
            {/* <DownloadIcon /> */}
            <ImportSVGIcon />
            <span style={{ fontSize: 12 }}>Download Image</span>
          </button>
          <button className="shape-btn" style={{ gap: 6, padding: '0px 15px', width: 'auto' }} title="Replace selected image" onClick={handleReplaceImage}>
            <ReplaceIcon />
            <span style={{ fontSize: 12 }}>Replace Image</span>
          </button>
          <div className="divider" />
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '0 8px' }}>
            <span style={{ fontSize: 11, color: '#6b7280', whiteSpace: 'nowrap' }}>Opacity</span>
            <input
              type="range"
              min="0"
              max="100"
              value={Math.round((imageItems.find((i) => i.id === selectedImageId)?.opacity ?? 1) * 100)}
              onChange={(e) => {
                dispatch(updateItem({ id: selectedImageId, opacity: Number(e.target.value) / 100 }));
              }}
              style={{ width: 80, cursor: 'pointer' }}
            />
            <span style={{ fontSize: 11, color: '#6b7280', minWidth: 28, textAlign: 'right' }}>
              {Math.round((imageItems.find((i) => i.id === selectedImageId)?.opacity ?? 1) * 100)}%
            </span>
          </div>
        </div>
      )}

      {showShapeBar && (
        <div className="sub-toolbar">
          {[
            { id: "freehand", icon: <FreehandIcon />, label: "Freehand"  },
            { id: "rect",     icon: <RectIcon />,     label: "Rectangle" },
            { id: "circle",   icon: <CircleIcon />,   label: "Circle"    },
          ].map((s) => (
            <button key={s.id} className={`shape-btn ${activeShape === s.id ? "active" : ""}`}
              onClick={() => dispatch(setActiveShape(s.id))} title={s.label}>
              {s.icon}
            </button>
          ))}
        </div>
      )}

      {showTextBar && (
        <div className="text-toolbar" onMouseDown={e => e.stopPropagation()}>
          <FontFamilyPicker value={fontFamily} onChange={(f) => dispatch(setFontFamily(f))} />
          <div className="text-divider" />
          <FontSizePicker value={fontSize} onChange={(s) => dispatch(setFontSize(s))} />
          <div className="text-divider" />
          <button type="button" className={`bold-btn ${bold ? "active" : ""}`}
            onClick={() => dispatch(setBold(!bold))} title="Bold">B</button>
          <div className="text-divider" />
          {[
            { id: "left",   icon: <AlignLeftIcon />,   label: "Align left"   },
            { id: "center", icon: <AlignCenterIcon />, label: "Align center" },
            { id: "right",  icon: <AlignRightIcon />,  label: "Align right"  },
          ].map((a) => (
            <button type="button" key={a.id} className={`align-btn ${textAlign === a.id ? "active" : ""}`}
              onClick={() => dispatch(setTextAlign(a.id))} title={a.label}>
              {a.icon}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}